import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconDot } from 'src/assets/icons/Dot';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const DetectedViolation = ({ className, classes, detectedViolation }) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        <IconDot className={styles.icon} />
        <CustomTypography className={styles.issue}>Issue:</CustomTypography>
        <CustomTypography>{detectedViolation.text}</CustomTypography>
      </div>

      <CustomTypography
        className={styles.explanation}
        variant={TYPOGRAPHY_VARIANT.regular12}
      >
        {detectedViolation.explanation}
      </CustomTypography>
    </div>
  );
};

DetectedViolation.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  detectedViolation: PropTypes.shape({
    text: PropTypes.string,
    explanation: PropTypes.string,
  }).isRequired,
};

DetectedViolation.defaultProps = {
  className: '',
  classes: null,
};
